'use client';

import { OnboardingEvents, trackTagManagerEvent } from 'firebase-client';
import { useRouter } from 'next/navigation';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Button, Typography } from 'ui';

import { useCreateAccount } from '~/onboarding';
import { Icon } from '~/ui/wizard';

export const CompletionStep = () => {
  const { t } = useTranslation('register');
  const { onCompletion, getAccountData } = useCreateAccount();
  const { replace } = useRouter();

  const { email } = getAccountData();

  const goToHome = () => {
    trackTagManagerEvent(OnboardingEvents.openHomePage);
    replace('invoices');
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Icon source="/images/completion.svg" alt="completion" />
        <Box mt={2}>
          <Trans
            i18nKey="register:steps.completion.description"
            values={{
              email,
            }}
            components={[<Typography display="inline" fontWeight="bold" />, <Typography display="inline" />]}
          />
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button size="lg" color="gradient" fullWidth onClick={onCompletion} data-testid="create-account-button">
          {t('createAccount')}
        </Button>

        <Button size="lg" color="lightGrey" fullWidth onClick={goToHome} data-testid="go-home-button">
          {t('login')}
        </Button>
      </Box>
    </Box>
  );
};
